import React from 'react'
import NotificationIcon from 'components/NotificationIcon'
import Colors from 'utils/Colors'

/** Requires parent component style to be position: relative to adjust. */
const PauseNotificationIcon = ({ bottomPosition, topPosition, leftPosition, rightPosition, style }) => {
  return (
        <NotificationIcon
          color={Colors.darkBlue}
          backgroundColor={Colors.white}
          borderColor={Colors.blue}
          topPosition={topPosition}
          rightPosition={rightPosition}
          leftPosition={leftPosition}
          bottomPosition={bottomPosition}
          
          style={style}
        >
          <strong>II</strong>
        </NotificationIcon>
  )
}

export default PauseNotificationIcon
